<!--  抽卡结果-->
<template>
  <div class="drawCard" v-show="show">
    <div class="box">
      <h1>{{cardName}}</h1>
      <h2>集齐5张可合成张宇定制版盲盒</h2>
      <img class="img" :src="cardIcon" />
      <div class="btn">
        <button class="accept" @click="changeShow">开心收下</button>
        <button class="continue" @click="drawCard" v-if="activityUserInfo.remainingTimes">
          继续抽卡
          <p>（{{ activityUserInfo.remainingTimes }}次）</p>
        </button>
      </div>
      <div class="close" @click="changeShow"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      cardIcon: '',
      cardName:'',

    };
  },
  props: {
    cardVOSList: {
      type: Array,
      default: () => [],
    },
    lotteryRes: {
      type: String,
      default: '',
    },
    activityUserInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {
    lotteryRes(code) {
      const res = this.cardVOSList.find((item) => {
        return item.cardCode == code;
      });
      this.cardIcon = res?.cardIcon;
      this.cardName=res?.cardName
    },
  },
  methods: {
    changeShow() {
      this.show = !this.show;
    },
    drawCard() {
      this.changeShow()
      this.$emit('continueLottry');
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.drawCard {
  position: fixed;
  top: 0;
  left: 0;
   z-index: 10;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  background: rgba($color: #000, $alpha: 0.8);
  .box {
    width: 100%;
    min-height: 886px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/lottery-res.png')
      no-repeat;
    background-size: 100%;
    h1 {
      padding-top: 90px;
      color: #fff;
      font-weight: 500;
      font-size: 30px;
      text-align: center;
    }
    h2 {
      padding: 14px 0 12px 0;
      color: #fff;
      font-weight: 400;
      font-size: 28px;
      text-align: center;
    }
    .img {
      display: block;
      width: 519px;
      height: 692px;
      margin: 0 auto 36px;
       animation: flip 4s infinite linear;
    }
    .btn {
      display: flex;
      justify-content: space-around;
      margin: 36px auto 40px;
      padding: 0 116px;

      button {
        display: block;
        width: 250px;
        height: 80px;
        color: #fff;
        font-weight: 500;
        font-size: 32px;
        border-radius: 40px;
      }
      .accept {
        line-height: 80px;
        background: linear-gradient(180deg, #f86e77 0%, #ff2d5d 100%);
      }
      .continue {
        background: linear-gradient(180deg, #ffd64e 0%, #ff9c1c 100%);
        p {
          color: #fff;
          font-weight: 400;
          font-size: 22px;
          line-height: 30px;
          text-align: center;
        }
      }
    }
    .close {
      width: 66px;
      height: 66px;
      margin: 0 auto;
      background-image: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/close.png');
      background-size: 100%;
    }
  }
}
  @keyframes flip {
    0% {
      transform: perspective(1000px) rotateY(0deg);
    }
     33% {
      transform: perspective(1000px) rotateY(10deg);
    }
     66% {
      transform: perspective(1000px) rotateY(-10deg);
    }
     100% {
      transform: perspective(1000px) rotateY(0deg);
    }
   
  }
 
</style>
